module.exports = __webpack_public_path__ + "assets/img/more_img.2a4a0b2f.png";